<template>
    <div>
        <!-- 系统列表 -->
        <a-table id="mySocketTable" :columns="columns" :data-source="tableData" :scroll="{ x: clientWidth}"
            :pagination="false" :loading="tloading"  :rowKey="(record,index)=>{return index}">
            <template slot="operation" slot-scope="text, record">
                <!-- <router-link class="tableLink" :to="{path:'detail_templete',query: {id: record.id,}}">详情</router-link>
                <router-link class="tableLink"  :to="{path:'edit_templete',query: {id: record.id,}}">编辑</router-link> -->
                <a-popconfirm title="确认删除?" @confirm="() => handleDelete(record)">
                    <a class="tableLink"  href="javascript:;">删除</a>
                </a-popconfirm>
            </template>

            <template slot="onlineType" slot-scope="text">
                <span :style="{color:text == '0' ? 'red' : 'green'}">{{ text == '1' ? '在线' : '离线' }}</span>
            </template>

        </a-table>
        <a-modal v-model="jsonModalVisable" width="600px" title="attributes">
                <json-viewer
                :value="jsonVData"
                :expand-depth=5
                copyable
                boxed
                sort></json-viewer>
            </a-modal>
        <a-pagination style="float:right;margin-top:20px;" v-model="pagination.page" :pageSize="pagination.pageSize"
            :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />

    </div>
</template>
<script>
let pagination ={
    page:1,
    pageSize:10,
    total:0
};
import JsonViewer from "vue-json-viewer"
// createtime: "2021-11-29 17:06:56.0"
// deviceno: "125819504_001_1ab76e89eb11d1c4a6eeee565b7f6093_1"
// devicetype: ""
// isonline: "1"
// updatetime: "2021-12-01 13:57:28.0"
const columns = [
    {
        title: "序号",
        width: 50,
        align: "center",
        customRender: (text, record, index) => {
            let { page, pageSize } = pagination;
            return (Number(page) - 1) * Number(pageSize) + index + 1;
        },
    },

    {
        title: "设备号",
        dataIndex: "deviceno",
        width:400,
        ellipsis: true
    },
    
    {
        title: "设备类型",
        dataIndex: "devicetype",
        width:200,
        align:'center'
    },
    {
        title: "是否在线",
        dataIndex: "isonline",
        scopedSlots: { customRender: 'onlineType' },
        width:200,
        align:'center'
    },
    {
        title: "创建时间",
        dataIndex: "createtime",
        width:160,
        align:'center'
    },
    {
        title: "更新时间",
        dataIndex: "updatetime",
        width:160,
        align:'center'
    },
    {
        title: "操作",
        dataIndex: "updatetime",
        scopedSlots:{ customRender:'operation' },
        width:100,
        align:'center'
    },
    

];
export default {
    data() {
        return {
            columns,
            tableData:[],
            tloading:false,
            pagination,
            clientWidth:800,
            orderstr:'desc',
            jsonModalVisable:false,
            searchP:{},
            jsonVData:[]
        };
    },
    methods: {
        handleParamsJson(item){
            this.jsonVData = item.devicelist.split(',')
            this.jsonModalVisable = true;
        },
        handleParamsJsonData(item){
            this.jsonVData = JSON.parse(item.content)
            this.jsonModalVisable = true;
        },
        handlePageChange(v){
            this.pagination.page = v
            this.getAppSumData();
        },
        handleDelete(record){
            let that = this;
            that.$store.dispatch({
                type: "mcmsmanager/v3deleteDevice",
                params: {deviceno: record.deviceno}
            }).then((res) => {
                if (res.status == '200') {
                    that.pagination.page = 1;
                    that.getAppSumData()
                }
            });
        },
        getAppSumData(){
            let that = this
            that.tloading = true;
            let params = {
                ...that.searchP,
                ...that.pagination,
                urlparams:false
            };
            that.$store.dispatch({
                type: "mcmsmanager/querydevicev3page",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    that.tableData = result.list;
                    that.pagination.total = parseInt(result.totalRecords);
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
        handleSearch(searchP){
            this.searchP = searchP;
            this.pagination.page = 1;
            this.getAppSumData();
        }
    },

    components:{
        JsonViewer
    },
    mounted(){
    }
};
</script>
<style scoped>
    .trend_pagination{
        margin-top: 10px;
    }

    .tableLink{
        margin-right: 10px;
    }

</style>

